<!--第三方页面-->
<template>
  <div class="views-third-page">
  	<!-- header头 -->
    <div class="header" >
      <div class="back-btn" @click="goBack"><img src="@/assets/images/icon-back.png"></div>
      <div class="title">{{title}}</div>
    </div>
    <!-- 内容区 -->
    <div id="content" :class="{'content-wrapper':'true','consult':isConsult}">
      <iframe :src="url" scrolling="yes" id="ifr" width="100%" height="100%"></iframe>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: '',
  data() {
    return {
      title: '平安健康险',
      url: '',
      isConsult:false,
      showHeader: true,
    }
  },
  computed: {
    
  },
  methods: {
    goBack() {
      if (this.$store.state.preRoute) {
        this.$router.go(-1);
      } else {
        window.history.go(-1);
      } 
    },
  },
  mounted() {
    
  },
  created() {
    let query = this.$route.query;
    this.title = query.title || '平安健康险';
    let url = query.url || '';
    if(url.indexOf(".pdf") >= 0){
      let host = url.split('.com')[0] + '.com';
      this.url = host + '/share/pdf/pdfview.html?pdfUrl='+url;
    }else{
      this.url = query.url;
    }
    if(query.consult){
      this.isConsult=true;
    }
  }
}
</script>

<style scoped lang="stylus">
  .views-third-page
    width: 100%
    height: 100%
  .header
    width: 100%
    height: 1rem
    line-height: 1rem
    background-color: #fff
    color: #333
    text-align: center
    font-size: .34rem
    position: absolute
    top: 0
    left: 0
    display: flex
    z-index: 99
    border-bottom: 1px solid #f5f5f5
    .back-btn
      position: absolute
      top: .3rem
      left: .3rem
      width: .38rem
      height: .38rem
      img
        display: block
        width: 100%
        height: 100%  
    .title
      width: 100%
      text-align: center
  .content-wrapper
    padding-top: 1rem
    background-color: #fff
    width: 100%
    height: 100%
    overflow-x: hidden
    overflow-y: scroll
    -webkit-overflow-scrolling:touch
    iframe
      width: 100%
      height: 100%
      border: none
  .consult
    transform: scale(0.5,0.5) translate(-50%,-50%);
    width: 200%;
    height: 200%;
</style>
